import React from 'react';
import clazz from 'classnames';
import PictureGallery from '@/components/PictureGallery';
import styles from './index.module.less';
export default function SceneIntroduction(props) {
    const { className, style = {}, title, text, children, atlas } = props;
    return (<div id="scene-introduction" className={clazz(styles['scene-introduction'], className)} style={style}>
      <header>{title}</header>

      <main>
        
        <div className={styles['scene-introduction-text']}>{text}</div>

        

        <div className={styles['scene-introduction-imgs']}>
          {atlas && atlas.length > 0 && <PictureGallery atlas={atlas}/>}
        </div>

        
        <div className={styles['scene-introduction-children']}>{children}</div>
      </main>
    </div>);
}
